import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import { title } from 'models/planning';
// Custom
import { listRowSpecsShape, planningDataShape } from 'constants/PropTypesShapes';
import { planningsShowPath } from 'installations/navigation';
import { EditIconButton, DeleteIconButton } from 'components/buttons/IconButtons';
import ResourceAsyncStatusIcon from 'components/items/ResourceAsyncStatusIcon';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import InfoCheckbox from 'components/misc/InfoCheckbox';
import EntityIdLabel from 'installations/assets/entities/EntityIdLabel';

const PlanningRow = React.forwardRef(({
  id, planning, rowSpecs, withEntity,
  onDelete,
}, ref) => {
  const { id: planningId } = planning;

  // Permissions
  const { pInstallation: { planningWrite, entityRead } } = permissions;

  // Handlers
  const handleDelete = () => {
    onDelete(planning);
  };

  return (
    <TableRow
      ref={ref}
      element={planning}
      rowSpecs={rowSpecs}
      actions={[
        <OnlyWith
          key="bEdit"
          permissions={{
            needed: `${planningWrite}&&${entityRead}`,
            permissionsOrContext: 'installationPermissions',
          }}
        >
          <EditIconButton path={planningsShowPath(id, planningId)} />
        </OnlyWith>,
        <OnlyWith
          key="bDelete"
          permissions={{
            needed: planningWrite,
            permissionsOrContext: 'installationPermissions',
          }}
        >
          <DeleteIconButton onClick={handleDelete} />
        </OnlyWith>,
      ]}
    >
      <TableCell className={classnames({ 'table-first-details': rowSpecs.withDetails })}>
        <TruncatedTooltipText>{title(planning)}</TruncatedTooltipText>
      </TableCell>
      {withEntity && (
        <TableCell className="hidden-sm-down">
          <EntityIdLabel id={planning.entity_id} />
        </TableCell>
      )}
      <TableCell className="table-content-1 table-content-center hidden-xs-down" noPadding>
        <InfoCheckbox value={planning.enabled} />
      </TableCell>
      <TableCell className="table-content-1 table-content-center">
        <div className="d-flex align-items-center">
          <ResourceAsyncStatusIcon resource={planning} idKey="idPlanning" />
        </div>
      </TableCell>
    </TableRow>
  );
});

PlanningRow.displayName = 'PlanningRow';

PlanningRow.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  planning: planningDataShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  withEntity: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
};

PlanningRow.defaultProps = {
  onDelete: null,
};

module.exports = PlanningRow;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/plannings/PlanningRow.js